import React, {useState} from "react"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import QueueNumber from "./QueueNumber"
import {ServiceCardType} from "../Types"
import {useTranslation} from "react-i18next"
import BackButton from "../Common/BackButton"
import TakeQueueNumberButton from "./TakeQueueNumberButton"

interface RegistrationServiceProps {
    onBack: () => void
}

const RegistrationService = ({onBack}: RegistrationServiceProps) => {
    const { t } = useTranslation()

    const [queueNumber, setQueueNumber] = useState<number|null>(null)
    const [serviceCard, setServiceCard] = useState<ServiceCardType>()

    return (<>
        {queueNumber === null &&
            <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
                <Grid>
                </Grid>
                <Grid>
                    <Typography variant="h4">
                        {t('selfService.registrationCustomersAreServedByQueueNumber')}
                    </Typography>
                </Grid>
                <Grid>
                    <TakeQueueNumberButton
                        queueType='registration'
                        setServiceCard={setServiceCard}
                        setQueueNumber={setQueueNumber}
                    />
                </Grid>
                <Grid style={{textAlign: 'center'}}>
                    <Typography variant="subtitle1" gutterBottom>
                        {t('selfService.pleaseHaveRegistrationAndIdReady')}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        {t('selfService.prefillTransferForm')}
                    </Typography>
                </Grid>
                <Grid className="footerButtons">
                    <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                        <Grid>
                            <BackButton onBack={onBack} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        }
        {queueNumber !== null &&
            <QueueNumber serviceCard={serviceCard} queueNumber={queueNumber}/>
        }
    </>)
}

export default RegistrationService
